import { ToastModule } from 'primeng/toast';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CalendarModule, PanelModule, ScrollPanelModule, TabViewModule, MenuModule, CheckboxModule, ButtonModule, InputTextModule, DropdownModule, InputMaskModule, MessageService, CardModule, AccordionModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module

import { PicardServicesLibModule, httpFactory, HttpClientInterceptor } from '@picard/services-lib';

import { AppComponent } from './app.component';

import { AppRoutes } from './app.routing';

import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ProfileComponent } from './views/profile/profile.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { AuthorizationFailedComponent } from './views/authorization-failed/authorization-failed.component';
import { ErrorComponent } from './views/error/error.component';
import { Http, XHRBackend, RequestOptions, HttpModule } from '@angular/http';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HistoryComponent } from './views/history/history.component';

import { BlockUIModule } from 'ng-block-ui';
import { MergeAccountComponent } from './views/merge-account/merge-account.component';
import { TermsConditionsComponent } from './views/terms-conditions/terms-conditions.component';
import { StaticTermsComponent } from './views/terms-conditions/static-terms/static-terms.component';
import { PrivacyComponent } from './views/privacy/privacy.component';
import { BasketManagerComponent } from './views/basket-manager/basket-manager.component';
import { LoginComponent } from './views/login/login.component';
import { BreadcrumbComponent } from './layout/breadcrumb/breadcrumb.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HostComponent } from './layout/host/host.component';
import { MenuComponent } from './layout/menu/menu.component';
import { SubMenuComponent } from './layout/sub-menu/sub-menu.component';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { OnlyNumberDirective } from './directives/num-only.directive';
import { MobileComponent } from './views/history/mobile/mobile.component';
import { RegisterComponent } from './views/register/register.component';
import { LocationsComponent } from './views/locations/locations.component';
import { ActivateAccountComponent } from './views/activate-account/activate-account.component';

import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { environment } from '../environments/environment';
import { VisitedUsBeforeComponent } from './views/visited-us-before/visited-us-before.component';
import { LoyaltyNumberComponent } from './views/loyalty-number/loyalty-number.component';
import { OtpComponent } from './views/otp/otp.component';
import { VoucherComponent } from './views/voucher/voucher.component';
import { VoucherHistoryComponent } from './views/voucher-history/voucher-history.component';
import { VoucherHistoryMobileComponent } from './views/voucher-history/voucher-history-mobile/voucher-history-mobile.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { StoresComponent } from './views/stores/stores.component';
import { VoucherLandingComponent } from './views/voucher-landing/voucher-landing.component';

@NgModule({
  imports: [
    HttpModule,
    HttpClientModule,
    BrowserModule, BrowserAnimationsModule, CommonModule,
    FormsModule, ReactiveFormsModule,
    DropdownModule,
    NgxPaginationModule,
    CalendarModule, MessageModule, MessagesModule, PanelModule, CardModule, ScrollPanelModule, TableModule, TabViewModule, MenuModule, CheckboxModule, ButtonModule, InputTextModule, DropdownModule, InputMaskModule, TooltipModule,
    RouterModule.forRoot(AppRoutes, { useHash: true }),
    BlockUIModule.forRoot(),
    PicardServicesLibModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsKey,
      libraries: ['geometry']
    }),
    AgmDirectionModule,
    NgxSliderModule,
    AccordionModule
  ],
  declarations: [
    OnlyNumberDirective,
    AppComponent, LoginComponent, BreadcrumbComponent, FooterComponent, HostComponent, MenuComponent, SubMenuComponent, TopbarComponent, DashboardComponent, ProfileComponent, NotFoundComponent, AuthorizationFailedComponent, ErrorComponent, HistoryComponent, MergeAccountComponent, TermsConditionsComponent, StaticTermsComponent, PrivacyComponent, BasketManagerComponent, MobileComponent, RegisterComponent, LocationsComponent, VisitedUsBeforeComponent, LoyaltyNumberComponent, OtpComponent, ActivateAccountComponent, VoucherComponent, VoucherHistoryComponent, VoucherHistoryMobileComponent, StoresComponent, VoucherLandingComponent],
  exports: [StaticTermsComponent],
  providers: [{ provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] },
  { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true }, MessageService, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
